import { Colors } from '../../theme'

export default {
  searchBarInput: {
    color: Colors.Palette.primaryTextColor,
    width: 320,
    ['@media all and (max-width:375px)']: { // eslint-disable-line no-useless-computed-key
      width: '100%',
      maxWidth: 240,
      '& div:first-child': {
        lineHeight: 0.8
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/styles/components/search-bar.js